import { useLocation } from 'react-router'
import { Navigate } from 'react-router-dom'

import { ActivityIndicator } from '../../components'
import ActualPaymentPlan from '../../components/settings/actual-payment-plan'
import ApiKeys from '../../components/settings/api-keys'
import Assessment from '../../components/settings/assessment'
import Automations from '../../components/settings/automations'
import CompanyProfile from '../../components/settings/company-profile'
import DashboardComponents from '../../components/settings/dashboard-components'
import Integrations from '../../components/settings/integrations'
import MailTemplates from '../../components/settings/mail-templates'
import Notifications from '../../components/settings/notifications'
import ResultReports from '../../components/settings/result-reports'
import SampleDataSettings from '../../components/settings/sample-data-settings'
import TableColumnDefaults from '../../components/settings/table-column-defaults'
import TalentStatuses from '../../components/settings/talent-statuses'
import UserManagement from '../../components/settings/user-management'
import UserProfile from '../../components/settings/user-profile'
import { settingsPathFromHash } from '../../helpers/settingsTab'
import { useCareersQuery } from '../../hooks/use-careers-query'

// /settings ohne Unterseite, also auch alte Links wie /settings#plan
const SettingsRedirect = () => {
  const { hash } = useLocation()
  return <Navigate replace to={settingsPathFromHash(hash)} />
}

// Nur die Ergebnisreports brauchen die Stellen, die übrigen Unterseiten
// warten nicht darauf
const ResultReportsSection = () => {
  const { status, data: careers } = useCareersQuery({
    select: (items) => items.filter(({ archived }) => !archived)
  })

  if (status === 'pending') return <ActivityIndicator />

  return <ResultReports careers={careers} />
}

const DashboardSection = () => (
  <>
    <DashboardComponents />
    <TableColumnDefaults className='mt-12' />
    <SampleDataSettings className='mt-12' />
  </>
)

// Kindrouten von /settings, gerendert im Outlet von SettingsLayout. Die Pfade
// entsprechen SETTINGS_SECTIONS in helpers/settingsTab.
export const settingsRoutes = [
  { index: true, Component: SettingsRedirect },
  { path: 'personal', Component: UserProfile },
  { path: 'notifications', Component: Notifications },
  { path: 'company', Component: CompanyProfile },
  { path: 'user', Component: UserManagement },
  { path: 'templates', Component: MailTemplates },
  { path: 'assessment', Component: Assessment },
  { path: 'talent-status', Component: TalentStatuses },
  { path: 'resultreport', Component: ResultReportsSection },
  { path: 'dashboard', Component: DashboardSection },
  { path: 'plan', Component: ActualPaymentPlan },
  { path: 'integrations', Component: Integrations },
  { path: 'ats', Component: ApiKeys },
  { path: 'automations', Component: Automations },
  { path: '*', Component: SettingsRedirect }
]
